import { tableNodes } from 'prosemirror-tables';
import { tableColumnWidth } from '@/editor/editor-block/constants';

export default tableNodes({
  tableGroup: 'block',
  cellContent: '(paragraph | heading | bullet_list | ordered_list)+',
  cellAttributes: {
    colwidth: {
      default: [tableColumnWidth],
    },
  },
});
